import { useCallback, useEffect, useRef, useState } from "react";
import { Button, ButtonProps, CircularProgress } from "@mui/material";
import "./AedasButton.css";

// Cooldown de seguridad para acciones que no devuelven una promesa (la mayoría
// de handlers del proyecto hacen fire-and-forget de la llamada a la API): sin
// esto, un doble clic dispara la acción dos veces antes de que llegue la
// primera respuesta. Si el handler SÍ devuelve una promesa, el botón se
// reactiva en cuanto se resuelve, sin esperar al cooldown.
const DOUBLE_CLICK_GUARD_MS = 1000;

export const AedasButton = ({
  className,
  onClick,
  disabled,
  children,
  ...props
}: ButtonProps) => {
  const [busy, setBusy] = useState(false);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      if (!onClick || busy) return;
      setBusy(true);
      const result: any = onClick(event);
      if (result && typeof result.then === "function") {
        result.finally(() => {
          if (mountedRef.current) setBusy(false);
        });
      } else {
        setTimeout(() => {
          if (mountedRef.current) setBusy(false);
        }, DOUBLE_CLICK_GUARD_MS);
      }
    },
    [onClick, busy],
  );

  return (
    <Button
      className={`aedas-button${className ? ` ${className}` : ""}`}
      onClick={handleClick}
      disabled={disabled || busy}
      {...props}
    >
      {busy ? <CircularProgress size={18} color="inherit" /> : children}
    </Button>
  );
};
